/* eslint-disable */
import {
  Box,
  fade,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { useState } from 'react';
import PatientCreateModal from '../Patients/Item/Create/PatientCreateModal';
import ContentWrapper from 'components/Wrappers/ContentWrapper';
import RoundedButton from 'components/Shared/RoundedButton';
import emptyDataIcon from 'assets/placeholders/emptyState.svg';
import { useDispatch, useSelector } from 'react-redux';
import { ALL_ROUTES } from '../../config/routes';
import Charts from './Charts';
import { REQUEST_STATUS, TABLE_KEYS, navigateToRoute } from '../../redux_store';
import { ASSESSMENTS_ALERTS_COLUMNS } from './constants';
import QhsTable from '../Shared/Table/Table';
import { useGenerateColumns } from '../Shared/Table/helpers';
import TableTitle from '../Shared/Table/widgets/TableTitle';
import InfoBlocks from './widgets/InfoBlocks';

const useStyles = makeStyles((theme) => ({
  gridItem: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    padding: 24,
    borderRadius: theme.shape.borderRadius,
    height: '100%',
    marginRight: theme.spacing(3),
    minHeight: 440,
    [theme.breakpoints.down('md')]: {
      marginRight: theme.spacing(0),
    },
  },
  addNewButton: {
    height: '100%',
    marginRight: theme.spacing(2),
  },
  divider: {
    width: '100%',
    margin: theme.spacing(4, 0),
  },
  emptyDataWidget: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    flexDirection: 'column',
  },
  emptyDataTitle: {
    marginTop: theme.spacing(2),
    color: fade(theme.colors.blue2, 0.5),
  },
}));

const DashboardComponent = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { en: { titles, btn, tables } } = useSelector((state) => state.i18n);
  const {
    metadata: { currentAccount },
  } = useSelector((state) => state.user);
  const { assessmentAlerts, status } = useSelector((state) => state.charts);
  const [openPatientModal, togglePatientModal] = useState(false);

  const redirectToAssessmentReport = ({
                                        uuid,
                                        accountUUID,
                                        patientUUID,
                                        surveyName,
                                      }) => {
    dispatch(navigateToRoute({ route: {
      path: ALL_ROUTES.assessment.report.path,
      params: {
        currentAccountUuid: accountUUID,
        patientUuid: patientUUID,
        assessmentUuid: uuid,
        status: 'pendingReview',
      },
      title: `${surveyName} ${titles.report}`,
    }}));
  };
  const isTableDataLoading = status !== REQUEST_STATUS.succeeded || !assessmentAlerts;
  const tableKey = TABLE_KEYS.dashboardAssessmentsAlertsTable;
  const columns = useGenerateColumns(ASSESSMENTS_ALERTS_COLUMNS, tableKey, {}, {}).columns;

  return (
    <>
      <PatientCreateModal
        open={openPatientModal}
        accountUuid={currentAccount.uuid}
        handleClose={() => togglePatientModal(false)}
      />
      <ContentWrapper
        titleText={titles.dashboard}
        actions={
          <RoundedButton
            size="small"
            color="primary"
            variant="outlined"
            className={classes.addNewButton}
            onClick={() => togglePatientModal(true)}
            disableTextUppercase={true}
            style={{
              height: 49,
            }}
          >
            {btn.addPatient}
          </RoundedButton>
        }
      >
        {status === REQUEST_STATUS.failed ? (
          <div className={classes.emptyDataWidget}>
            <img alt="" src={emptyDataIcon} />
            <Typography className={classes.emptyDataTitle}>
              Error loading data
            </Typography>
          </div>
        ) : (
          <>
            <Box p={2}>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={8}>
                  <div className={classes.gridItem}>
                    <QhsTable
                      columns={columns}
                      data={assessmentAlerts || []}
                      isFetching={isTableDataLoading}
                      isLoading={isTableDataLoading && !assessmentAlerts}
                      totalRowCount={assessmentAlerts?.length}
                      tableKey={tableKey}
                      onRowClick={redirectToAssessmentReport}
                      maxHeight={400}
                      tableTitle={<TableTitle
                        titleText={tables.assessmentsAlerts}
                        smallStyle
                      />}
                    />
                  </div>
                </Grid>
                <InfoBlocks />
              </Grid>
            </Box>
            <Divider className={classes.divider} />
            <Box p={2}><Charts /></Box>
          </>
        )}
      </ContentWrapper>
    </>
  );
};

export default DashboardComponent;
